import { styled } from "styled-components";

export const SuccessMessageContainer = styled.div`
  height: 700px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
